import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ConversationsList from './ConversationsList'

export default function Conversations() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/conversations" component={ConversationsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}